<template>
  <div
    class="mx-auto Kanit"
    style="
      display: flex;
      flex-flow: column;
      position: absolute;
      height: 100%;
      max-width: 500px;
    "
  >
    <div
      class="pa-4 text-center white--text Kanit"
      style="font-size: 22px; background-color: #002969"
    >
      ข้อตกลงและเงื่อนไขการใช้งาน
    </div>

    <v-card
      class="ma-4 pa-3"
      style="overflow-y: scroll; font-size: 15px"
      color="#eee"
    >
      <div class="Kanit">
        <div>
          <!-- <h1 style="font-weight: 700; text-decoration: underline font-s">ข้อตกลงและเงื่อนไขการใช้งาน</h1> -->
          <div style="font-weight: 500; text-decoration: underline; margin-bottom: 8px;">คำจำกัดความ</div>
          <p>“ท่าน” หมายถึง ผู้ใช้บริการแอปพลิเคชั่นสะสมเครื่องของบริษัท วาย เอ เซลส์ แอนด์ เซอวิสเซส จำกัด</p>
          <p>“บริษัท” หมายถึง บริษัท วาย เอ เซลส์ แอนด์ เซอวิสเซส จำกัด</p>
          <p>‘ข้อมูลส่วนบุคคล” หมายถึง ข้อมูลเกี่ยวกับบุคคลซึ่งทำให้สามารถระบุตัวบุคคลนั้นได้ ไม่ว่าทางตรงหรือทางอ้อม แต่ไม่รวมถึงข้อมูลของผู้ถึงแก่กรรมโดยเฉพาะ ตามกฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคล</p>
          <p>"ข้อตกลงและเงื่อนไขเพิ่มเติม" หมายถึง ข้อตกลงและเงื่อนไขอื่นใดซึ่งแยกต่างหากจากข้อตกลงและเงื่อนไขการใช้งานฉบับนี้ และเกี่ยวข้องกับบริการซึ่งเผยแพร่หรืออัพโหลดโดยบริษัท ภายใต้ชื่อ "ข้อตกลง" "แนวทางปฏิบัติ" "นโยบาย" หรือภายใต้ชื่ออื่นๆ ที่มีความหมายคล้ายคลึงกัน</p>
        </div>
        <div>
          <div style="font-weight: 500; margin-bottom: 4px; font-size: 16pxl">1.&nbsp;&nbsp;&nbsp;การตกลงตามข้อตกลงและเงื่อนไขการใช้งาน</div>
          <ul style="margin-bottom: 12px;">
            <li style="margin-bottom: 2px;">ท่านจะต้องใช้บริการตามข้อกำหนดที่ระบุไว้ในข้อกำหนดและเงื่อนไขการใช้งานฉบับนี้ โดยท่านจะไม่สามารถใช้บริการได้ เว้นแต่ท่านได้ตกลงยอมรับข้อกำหนดและเงื่อนไขการใช้งานฉบับนี้แล้ว ความตกลงยินยอมดังกล่าวมีผลสมบูรณ์ การไม่ปฏิบัติตามข้อตกลงและเงื่อนไขการใช้งาน รวมทั้งข้อตกลงและเงื่อนไขเพิ่มเติมที่เกี่ยวข้อง มีผลทำให้ท่านไม่สามารถใช้บริการได้โดยที่บริษัทไม่จำเป็นต้องบอกกล่าวให้ท่านทราบ</li>
            <li style="margin-bottom: 2px;">หากมีข้อตกลงและเงื่อนไขเพิ่มเติมใดๆ ซึ่งเกี่ยวข้องกับการให้บริการ ท่านจะต้องปฏิบัติตามข้อตกลงและเงื่อนไขการใช้งานเพิ่มเติมดังกล่าวเช่นเดียวกับข้อตกลงและเงื่อนไขการใช้งานในการใช้งานฉบับนี้
            </li>
            <li style="margin-bottom: 2px;">บริษัทอาจเปลี่ยนแปลงแก้ไขข้อตกลงและเงื่อนไขฉบับนี้ได้ตลอดเวลาตามที่บริษัทเห็นสมควร ซึ่งจะอยู่ภายใต้ขอบวัตถุประสงค์ของข้อตกลงและเงื่อนไขฉบับนี้ ทั้งนี้ บริษัทจะแจ้งเนื้อหาของข้อตกลงและเงื่อนไขฉบับแก้ไข รวมถึงวันที่มีผลบังคับใช้บนเว็บไซต์ของบริษัทหรืออาจแจ้งให้ผู้ใช้ทราบด้วยวิธีการอื่นใดตามที่บริษัทกำหนด</li>
          </ul>
          <div style="font-weight: 500; margin-bottom: 4px;">2.&nbsp;&nbsp;&nbsp;การลงทะเบียน</div>
          <ul style="margin-bottom: 12px;">
            <li style="margin-bottom: 2px;">ท่านต้องทำการลงทะเบียนเพื่อเปิดบัญชีใช้บริการด้วยข้อมูลที่ถูกต้อง เป็นจริง ครบถ้วน รวมทั้งท่านมีหน้าที่ต้องปรับปรุงและแก้ไขข้อมูลให้เป็นปัจจุบันอยู่เสมอ</li>
            <li style="margin-bottom: 2px;">บริษัทอาจขอให้ท่านส่งเอกสารที่จำเป็นหรือดำเนินการใดๆ เพิ่มเติม เช่น สำเนาเอกสารระบุตัวตน เพื่อใช้ในการยืนยันตัวตนของท่าน</li>
            <li style="margin-bottom: 2px;">เพื่อความปลอดภัย บริษัทกำหนดให้มีรหัสผ่านเพื่อเข้าใช้บัญชี (“Login Password”) ซึ่งท่านจะต้องสร้างและกำหนดในขั้นตอนการลงทะเบียนบัญชีเพื่อใช้สำหรับการยืนยันตัวตนเข้าใช้งาน ท่านจะต้องไม่เปิดเผยรหัสผ่านให้บุคคลอื่นทราบโดยเด็ดขาด เพราะคำสั่งใดๆ ก็ตามที่ส่งผ่านบัญชีของท่านโดยใช้รหัสผ่านดังกล่าว ถือเป็นคำสั่งที่ถูกต้องสมบูรณ์และมีผลผูกพันเสมือนท่านได้ดำเนินการโดยตัวเอง หากท่านได้เปิดเผยรหัสผ่าน หรือสงสัยว่ารหัสผ่านของท่านถูกเปิดเผย บริษัทขอแนะนำให้ท่านเปลี่ยนแปลงรหัสผ่านใหม่ในทันที เพื่อความปลอดภัยของตัวท่าน ทั้งนี้ ท่านสามารถแก้ไขเปลี่ยนแปลงรหัสผ่านดังกล่าวได้ ตามวิธีการและหลักเกณฑ์ที่บริษัทกำหนด</li>
          </ul>
          <div style="font-weight: 500; margin-bottom: 4px;">3.&nbsp;&nbsp;&nbsp;การใช้งานแอปพลิเคชัน</div>
          <ul style="margin-bottom: 12px;">
            <li style="margin-bottom: 2px;">ในการใช้แอปพลิเคชัน ท่านสามารถเลือกใช้บริการ และ/หรือสินค้าที่นำเสนอในแอปพลิเคชันได้ ในกรณีที่การใช้บริการหรือสินค้าดังกล่าวมีข้อตกลงและเงื่อนไขการใช้งานเพิ่มเติม บริษัทขอให้ท่านอ่านข้อตกลงและเงื่อนไขการใช้งานเพิ่มเติมดังกล่าวให้ครบถ้วนเพื่อจะได้ปฏิบัติตามข้อตกลงและเงื่อนไขการใช้บริการหรือสินค้าดังกล่าวได้อย่างมีประสิทธิภาพ การไม่ปฏิบัติตามข้อตกลงและเงื่อนไขการใช้งานใดๆ มีผลทำให้ท่านไม่สามารถใช้บริการได้โดยที่บริษัทไม่จำเป็นต้องบอกกล่าวให้ท่านทราบ</li>
            <li style="margin-bottom: 2px;">หากมีการให้สิทธิประโยชน์ต่างๆ เพิ่มเติมจากการใช้งานแอปพลิเคชันของท่าน ข้อตกลงและเงื่อนไขต่างๆ จะเป็นไปตามที่บริษัทกำหนด</li>
          </ul>
          <div style="font-weight: 500; margin-bottom: 4px;">4.&nbsp;&nbsp;&nbsp;การจัดการข้อมูล</div>
          <ul style="margin-bottom: 12px;">
            <li style="margin-bottom: 2px;">ข้อมูลที่เกิดจากการใช้งานในแอปพลิเคชัน หรือข้อมูลอื่นใดที่ท่านได้ให้ไว้แก่บริษัท<span style="text-decoration: underline;">ซึ่งไม่ใช่ข้อมูลส่วนบุคคล</span>ท่านยินยอมให้บริษัทเปิดเผยข้อมูลต่อบริษัทในเครือของบริษัท พันธมิตรทางธุรกิจของบริษัท บุคคลภายนอกที่ร่วมมือกับบริษัทหรือให้บริการแก่บริษัท และหน่วยงานราชการที่เกี่ยวข้อง โดยการเก็บรวบรวม ใช้งาน ประมวลผล และ/เปิดเผยข้อมูลนั้นจะเป็นไปเพื่อวัตถุประสงค์ในการให้บริการ ดำเนินกิจกรรมทางการตลาด และ/หรือ ประชาสัมพันธ์สินค้าและบริการต่างๆ ตามที่บริษัทเห็นสมควร ซึ่งบริษัทจะไม่เปิดเผยข้อมูลส่วนบุคคลของท่านต่อบุคคลภายนอก เว้นแต่จะได้รับความยินยอมจากท่าน </li>
            <li style="margin-bottom: 2px;">บริษัทจะคุ้มครองความเป็นส่วนตัวและ<span style="text-decoration: underline;">ข้อมูลส่วนบุคคล</span>ของท่านอย่างเหมาะสมตาม <a href="https://drive.google.com/file/d/1xKs501RWaDm_LVKW0UJtvcyqECAkC-Y3/view">นโยบายการจัดการข้อมูลส่วนบุคคล"</a></li>
            <li style="margin-bottom: 2px;">ท่านตกลงจะให้หรือทำให้ข้อมูลที่ให้แก่บริษัทเป็นข้อมูลที่ถูกต้อง ครบถ้วน และเป็นปัจจุบัน ในกรณีที่ท่านมีการเปลี่ยนแปลงข้อมูลสำคัญที่ท่านให้ไว้กับบริษัท เช่น การเปลี่ยนที่อยู่จดหมายอิเล็กทรอนิกส์ (e-mail) หรือหมายเลขโทรศัพท์ ท่านจะต้องแก้ไขข้อมูลทันทีผ่านแอปพลิเคชัน หรือวิธีการอื่นใดที่บริษัทแจ้งให้ท่านทราบ</li>
          </ul>
          <div style="font-weight: 500; margin-bottom: 4px;">5.&nbsp;&nbsp;&nbsp;การระงับการใช้งานและการปิดบัญชี</div>
          <ul style="margin-bottom: 12px;">
            <li style="margin-bottom: 2px;">ในกรณีที่ท่านต้องการปิดบัญชี ท่านสามารถติดต่อบริษัทได้ที่เบอร์โทรศัพท์ 02-0165758  หรือดำเนินการขอปิดบัญชีโดยวิธีการอื่นใดที่บริษัทกำหนด เมื่อบัญชีของท่านปิดลง ท่านตกลงและรับทราบว่า ท่านจะไม่สามารถเข้าใช้บัญชีของท่านได้ ไม่สามารถใช้สิทธิต่างๆ ในบัญชีได้ รวมถึงอาจไม่สามารถใช้บริการหรือผลิตภัณฑ์ใดๆ ที่เป็นของบริษัท บริษัทในเครือ หรือพันธมิตรทางธุรกิจของบริษัทได้ ทั้งนี้ เป็นไปตามข้อตกลงและเงื่อนไขการใช้งานเพิ่มเติมของผลิตภัณฑ์นั้นๆ</li>
            <li style="margin-bottom: 2px;">บริษัทอาจทำการเลิกสัญญาและปิดบัญชีของท่านได้ หากมีการใช้บัญชี และ/หรือบริการแอปพลิเคชันของท่านในลักษณะที่ไม่เป็นไป หรือมีเหตุอันควรสงสัยว่าจะไม่เป็นไปตามข้อตกลงและเงื่อนไขการใช้งาน</li>
          </ul>
          <div style="font-weight: 500; margin-bottom: 4px;">6.&nbsp;&nbsp;&nbsp;ความรับผิดของผู้ใช้งาน</div>
          <p style="margin-bottom: 12px; padding-left: 24px;">ในการใช้งานแอปพลิเคชัน หากท่านใช้งานไม่เป็นไปตามข้อตกลงและเงื่อนไขการใช้งาน หรือไม่เป็นไปตามกฎหมายที่เกี่ยวข้อง และทำให้บริษัทและ/หรือบุคคลภายนอกต้องเสียหายจากการกระทำดังกล่าว ท่านตกลงจะรับผิดชอบชดใช้ค่าเสียหายดังกล่าวแต่เพียงผู้เดียวแก่บริษัทและ/หรือบุคคลภายนอก แล้วแต่กรณี</p>
          <div style="font-weight: 500; margin-bottom: 4px;">7.&nbsp;&nbsp;&nbsp;ข้อจำกัดความรับผิดของบริษัท</div>
          <ul style="margin-bottom: 12px;">
            <li style="margin-bottom: 2px;">บริษัทจะไม่รับผิดชอบใดๆ ต่อความเสียหายอันเกิดจากการกระทำของท่านในการใช้บริการ เว้นแต่ความเสียหายดังกล่าวมีส่วนเกิดจากการกระทำโดยเจตนาหรือโดยประมาทเลินเล่ออย่างร้ายแรงของบริษัท</li>
            <li style="margin-bottom: 2px;">ในกรณีท่านได้รับความเสียหายอันเนื่องมาจากการกระทำโดยประมาทเลินเล่ออย่างร้ายแรงของบริษัท บริษัทมีหน้าที่ใช้ค่าสินไหมทดแทนอันเกิดจากการละเมิดนั้น สำหรับความเสียหายที่เกิดขึ้นตามปกติธรรมดาและเป็นความเสียหายโดยตรงจากการประมาทเลินเล่ออย่างร้ายแรงของบริษัท</li>
          </ul>
        </div>
      </div>
      <div>
        <v-checkbox
          style="font-weight: 600"
          label="ข้าพเจ้าได้อ่านและเข้าใจข้อตกลงและเงื่อนไขการใช้งานฉบับนี้โดยละเอียดแล้ว และข้าพเจ้าตกลงที่จะปฏิบัติตามข้อตกลงและเงื่อนไขการใช้งาน"
          v-model="cbagree"
        ></v-checkbox>
      </div>
    </v-card>

    <div class="pa-5 mb-3 pt-0">
      <v-btn
        @click="submitpdpa"
        :loading="saveloading"
        :disabled="!cbagree"
        style="font-size: 22px"
        class="text-capitalize"
        color="primary"
        :dark="cbagree"
        block
        >ยอมรับ</v-btn
      >
      <v-btn
        @click="$liff.closeWindow()"
        style="font-size: 22px"
        class="mt-3 text-capitalize"
        color="#eee"
        :loading="saveloading"
        block
        >ไม่ยอมรับ</v-btn
      >
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      saveloading: false,
      cbagree: false,
    };
  },
  mounted() {},
  methods: {
    submitpdpa() {
      this.$emit("onAgree");
    },
  },
};
</script>

<style lang="scss">
html {
  height: 100%;
}
</style>
